/* ===========================================================================
   Custom colour swatches (free Swatch King alternative)
   Builds image swatches automatically from each colour's variant photo.
   Works on collection cards and the product page.
   Carousel with arrows when a product has more than 6 colours.
   ---------------------------------------------------------------------------
   v2: native colour picker hidden correctly, swatches survive Dawn's
       variant re-render, shape follows the CSS variable.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__csSwatchesLoaded) return;
  window.__csSwatchesLoaded = true;

  var COLOUR_RE = /colou?r|kleur|couleur|farve|farbe/i;
  var CAROUSEL_THRESHOLD = 6; // more than this -> carousel
  var productCache = new Map();

  var ARROW_LEFT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_RIGHT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- helpers ---------- */

  function getHandleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var p = fetch(root.replace(/\/$/, '') + '/products/' + handle + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    productCache.set(handle, p);
    return p;
  }

  function getOptionNames(product) {
    if (!product.options) return [];
    return product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function colourIndex(product) {
    var names = getOptionNames(product);
    for (var i = 0; i < names.length; i++) {
      if (COLOUR_RE.test(names[i])) return i;
    }
    return -1;
  }

  function sized(src, width) {
    if (!src) return src;
    if (src.indexOf('/cdn/shop') === -1 && src.indexOf('cdn.shopify') === -1) return src;
    return src.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, function (m, ext, q) {
      var sep = q ? q + '&' : '?';
      return ext + sep + 'width=' + width;
    });
  }

  function buildColours(product, idx) {
    var seen = {};
    var list = [];
    (product.variants || []).forEach(function (v) {
      var colour = v.options[idx];
      if (colour == null || seen[colour]) return;
      seen[colour] = true;
      var img =
        (v.featured_image && v.featured_image.src) ||
        product.featured_image ||
        (product.images && product.images[0]) ||
        '';
      list.push({
        colour: colour,
        image: img,
        variantId: v.id,
        url: product.url + '?variant=' + v.id,
        available: v.available
      });
    });
    return list;
  }

  function makeSwatch(item) {
    var el = document.createElement('button');
    el.className = 'cs-swatch';
    el.type = 'button';
    el.setAttribute('aria-label', item.colour);
    el.title = item.colour;
    el.dataset.colour = item.colour;
    el.dataset.image = item.image;
    el.dataset.url = item.url;
    if (item.image) el.style.backgroundImage = 'url("' + sized(item.image, 80) + '")';
    return el;
  }

  // Always a single-line horizontal carousel. Arrows appear only when the
  // swatches don't all fit (e.g. many colours, or a narrow phone screen).
  function renderContainer(items, makeEl) {
    var wrap = document.createElement('div');
    wrap.className = 'cs-swatches';

    var carousel = document.createElement('div');
    carousel.className = 'cs-carousel';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'cs-arrow cs-arrow--prev';
    prev.setAttribute('aria-label', 'Previous colours');
    prev.innerHTML = ARROW_LEFT;

    var track = document.createElement('div');
    track.className = 'cs-carousel__track';
    items.forEach(function (it) { track.appendChild(makeEl(it)); });

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'cs-arrow cs-arrow--next';
    next.setAttribute('aria-label', 'More colours');
    next.innerHTML = ARROW_RIGHT;

    function updateArrows() {
      var overflow = track.scrollWidth - track.clientWidth > 2;
      prev.disabled = !overflow || track.scrollLeft <= 2;
      next.disabled = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function step() {
      var s = track.querySelector('.cs-swatch');
      var w = s ? s.offsetWidth : 30;
      return (w + 6) * 3;
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); track.scrollLeft -= step(); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); track.scrollLeft += step(); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); });
    window.addEventListener('resize', function () { window.requestAnimationFrame(updateArrows); });

    carousel.appendChild(prev);
    carousel.appendChild(track);
    carousel.appendChild(next);
    wrap.appendChild(carousel);
    window.setTimeout(updateArrows, 0);
    window.setTimeout(updateArrows, 400); // re-check after fonts/images settle
    return wrap;
  }

  /* ---------- collection cards ---------- */

  function processCard(card) {
    if (card.dataset.csDone) return;
    card.dataset.csDone = '1';

    var link = card.querySelector('.card__heading a, a.full-unstyled-link, a[href*="/products/"]');
    var handle = link && getHandleFromUrl(link.getAttribute('href'));
    if (!handle) return;

    fetchProduct(handle).then(function (product) {
      if (!product) return;
      var idx = colourIndex(product);
      if (idx === -1) return;
      var colours = buildColours(product, idx);
      if (colours.length < 2) return;

      var mainImg = card.querySelector('.card__media img');
      var headingLink = card.querySelector('.card__heading a');

      var container = renderContainer(colours, function (item) {
        var el = makeSwatch(item);
        // Hover a card swatch = show that colour's photo in the card image.
        el.addEventListener('mouseenter', function () {
          swapCardImage(mainImg, item.image);
        });
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // Go to the product page for this specific colour.
          window.location.href = item.url;
        });
        return el;
      });

      // While the pointer is anywhere over the swatch strip, suppress the theme's
      // "second image on hover" (so it doesn't fight the colour preview). Bound on
      // the whole strip with enter/leave so moving between swatches never flickers.
      container.addEventListener('mouseenter', function () {
        card.classList.add('cs-suppress-hover');
      });
      container.addEventListener('mouseleave', function () {
        card.classList.remove('cs-suppress-hover');
        restoreCardImage(mainImg);
      });

      // Put the swatches ABOVE the title (right under the product image).
      var infos = card.querySelectorAll('.card__information');
      var info = null;
      infos.forEach(function (el) { if (el.querySelector('.card-information')) info = el; });
      if (!info) info = card.querySelector('.card__information');
      if (info) info.insertBefore(container, info.firstChild);
    });
  }

  function swapCardImage(img, src) {
    if (!img || !src) return;
    if (!img.dataset.csCached) {
      img.dataset.csCached = '1';
      img.dataset.csOrigSrc = img.getAttribute('src') || '';
      img.dataset.csOrigSrcset = img.getAttribute('srcset') || '';
    }
    // Safety net: if the swapped-in colour photo fails to load, fall back to the
    // original card image instead of leaving a broken-image icon.
    img.onerror = function () { img.onerror = null; restoreCardImage(img); };
    img.srcset = '';
    img.src = sized(src, 533);
  }
  function restoreCardImage(img) {
    if (!img || !img.dataset.csCached) return;
    img.onerror = null;
    if (img.dataset.csOrigSrcset) img.setAttribute('srcset', img.dataset.csOrigSrcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', img.dataset.csOrigSrc);
  }
  // Put every card image back to its original (used when returning via the
  // browser's back/forward cache, where a tapped-swatch swap would otherwise linger).
  function restoreAllCards() {
    document.querySelectorAll('img[data-cs-cached]').forEach(restoreCardImage);
    document.querySelectorAll('.cs-suppress-hover').forEach(function (c) {
      c.classList.remove('cs-suppress-hover');
    });
  }

  // Product page: swap the main gallery image (hover preview, like Swatch King).
  function getPdpMainImg() {
    var g = document.querySelector('media-gallery');
    if (!g) return null;
    return g.querySelector('.is-active img') || g.querySelector('li img') || g.querySelector('img');
  }
  function swapPdpImage(src) {
    if (!src) return;
    var img = getPdpMainImg();
    if (!img) return;
    img.srcset = '';
    img.src = sized(src, 1200);
  }

  function scanCards() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    if ('IntersectionObserver' in window && cardIO) {
      cards.forEach(function (card) {
        if (card.dataset.csObserved) return;
        card.dataset.csObserved = '1';
        cardIO.observe(card);
      });
    } else {
      cards.forEach(processCard);
    }
  }

  var cardIO =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                cardIO.unobserve(entry.target);
                processCard(entry.target);
              }
            });
          },
          { rootMargin: '300px' }
        )
      : null;

  /* ---------- product page ---------- */

  function findColourFieldset(vs) {
    var fss = vs.querySelectorAll(
      '.product-form__input--pill, .product-form__input--swatch, .product-form__input--dropdown'
    );
    for (var i = 0; i < fss.length; i++) {
      var inp = fss[i].querySelector('input[type="radio"], select');
      var leg = fss[i].querySelector('legend, label');
      var name = (inp && inp.name) || (leg && leg.textContent) || '';
      if (COLOUR_RE.test(name)) return fss[i];
    }
    return null;
  }

  function getCheckedColour(vs) {
    var fs = findColourFieldset(vs);
    if (!fs) return null;
    var r = fs.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    var s = fs.querySelector('select');
    if (s) return s.value;
    return null;
  }

  // Trigger the theme's own variant switch (price / gallery / availability).
  function selectNativeColour(vs, colour) {
    var fs = findColourFieldset(vs);
    if (!fs) return;
    var sel = fs.querySelector('select');
    if (sel) {
      sel.value = colour;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var inputs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === colour) {
        if (!inputs[i].checked) inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function hideNativeColour(vs) {
    var fs = findColourFieldset(vs);
    if (fs) fs.classList.add('cs-native-hidden');
  }

  function buildPdpStrip(product, colours) {
    var idx = colourIndex(product);
    var optName = getOptionNames(product)[idx] || 'Colour';

    var container = renderContainer(colours, function (item) {
      var el = makeSwatch(item);
      // NOTE: no hover-preview on the product page — let Dawn switch the gallery
      // natively on variant change (same behaviour as a normal variant button).
      // The custom preview used to briefly show the colour and then revert to the
      // first photo while Dawn was still re-rendering, which looked like a bug.
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Move the active ring to this swatch IMMEDIATELY (optimistic), so it
        // doesn't wait for Dawn's variant re-render — that lag looked like a glitch.
        var strip = el.closest('.cs-swatches');
        if (strip) {
          strip.querySelectorAll('.cs-swatch').forEach(function (s) {
            s.classList.toggle('is-active', s === el);
          });
          var lbl = strip.querySelector('.cs-pdp-selected');
          if (lbl) lbl.textContent = item.colour;
        }
        // Always look up the CURRENT variant-selects: Dawn may swap it out
        // for a fresh element on each variant change.
        var liveVs = document.querySelector('variant-selects');
        if (liveVs) selectNativeColour(liveVs, item.colour);
      });
      return el;
    });

    container.classList.add('cs-swatches--pdp');

    var label = document.createElement('div');
    label.className = 'form__label cs-pdp-label';
    label.innerHTML = optName + ': <span class="cs-pdp-selected"></span>';
    container.insertBefore(label, container.firstChild);

    return container;
  }

  // Idempotent: builds the strip once, then just keeps it in sync after
  // Dawn re-renders the variant picker on each variant change.
  function enhancePdp() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var handle = getHandleFromUrl(window.location.pathname);
    if (!handle) return;
    var parent = vs.parentNode;

    fetchProduct(handle).then(function (product) {
      if (!product) return;
      var idx = colourIndex(product);
      if (idx === -1) return;
      var colours = buildColours(product, idx);
      if (colours.length < 2) return;

      hideNativeColour(vs);

      var strip = document.querySelector('.cs-swatches--pdp');
      if (!strip) strip = buildPdpStrip(product, colours);
      if (strip.parentNode !== parent || strip.nextSibling !== vs) {
        parent.insertBefore(strip, vs);
      }

      var checked = getCheckedColour(vs);
      strip.querySelectorAll('.cs-swatch').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.colour === checked);
      });
      var sel = strip.querySelector('.cs-pdp-selected');
      if (sel) sel.textContent = checked || colours[0].colour;
    });
  }

  // Move the Kiwi "Size Chart" link so it sits directly next to the word "Size"
  // (instead of floating at the far right of the row). We relocate Kiwi's real
  // trigger element into the Size <legend>, right after the label text, so its
  // own click handler keeps working.
  function placeSizeChart() {
    // Placement of the Kiwi "Size Chart" link is controlled inside the Kiwi app
    // itself (Styles & Settings -> Sizing Injection Selector), NOT here. Kept as
    // a no-op so we never move Kiwi's link (moving it breaks its click handler).
    return;
  }

  /* ---------- orchestration ---------- */

  var pending = false;
  function rescan() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      enhancePdp();
      scanCards();
      placeSizeChart();
    });
  }

  function init() {
    rescan();
    // Watch for Shopify re-rendering (variant change, filtering, pagination, editor).
    if ('MutationObserver' in window) {
      new MutationObserver(rescan).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', rescan);
    document.addEventListener('shopify:section:select', rescan);
    // Returning via the browser back/forward cache (esp. mobile Safari): the page is
    // restored exactly as left, so a tapped-swatch image swap would still be showing.
    // Reset every card image back to its original photo.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) restoreAllCards();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
